import * as React from 'react';
import {
  AlignItems,
  Body3,
  Box,
  Color,
  Display,
  FlexDirection,
  Heading1,
  Image,
  Space,
} from '@gousto-internal/citrus-react';
import { useTypographyTokens } from '../../hooks/useTypographyTokens';

export function MenuEmptyState() {
  const h5TypographyTokens = useTypographyTokens('h5');

  return (
    <Box
      paddingH={4}
      paddingV={6}
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      alignItems={AlignItems.Center}
      bg={Color.White}
    >
      <Image
        src="/assets/recipe-placeholder-plate-x250.webp"
        alt=""
        width="124px"
        style={{
          objectFit: 'contain',
          borderRadius: '50%',
          boxShadow: '8px 10px 10px rgba(0, 0, 0, 0.05)',
        }}
      />

      <Space size={4} />

      <Heading1 color={Color.ColdGrey_600} {...h5TypographyTokens}>
        We haven’t cooked up anything here!
      </Heading1>

      <Space size={1} />

      <Body3>Try changing your filters to see what’s on the menu.</Body3>
    </Box>
  );
}
